// import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { PaymentModeResponseModel, AllPaymentResponseModel } from '@gtpl/shared-models/masters';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import { UserRequestDto } from '../countries/dto/user-request-dto';
import { PaymentModeDTO } from './dto/payment-mode.dto';
import { PaymentModeService } from './payment-mode.service';
@ApiTags('payment-mode')
@Controller('paymentmodes')
export class PaymentModeController {
    constructor(private paymentModeService: PaymentModeService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler
      ) {}

    @Post('/createPaymentMode')
    async createPaymentMode(@Body() paymentModeDTO:PaymentModeDTO,isUpdate:boolean=false): Promise<PaymentModeResponseModel> {
    try {
        return await this.paymentModeService.createPaymentMode(paymentModeDTO, false);
    } catch (error) {
        // return errorHandler(PaymentModeResponseModel,error);
        return this.applicationExceptionHandler.returnException(PaymentModeResponseModel, error);
    }
    }
  
  @Post('/updatePaymentMode')
  async updatePaymentMode(@Body() paymentModeDTO: PaymentModeDTO): Promise<PaymentModeResponseModel> {
    try {
      return await this.paymentModeService.createPaymentMode(paymentModeDTO, true);
    } catch (error) {
      // return errorHandler(PaymentModeResponseModel, error);
      return this.applicationExceptionHandler.returnException(PaymentModeResponseModel, error);
    }
  }
  @Post('/getAllPaymentModes')
  async getAllPaymentModes(@Body() req:UserRequestDto): Promise<AllPaymentResponseModel> {
    try {
      return await this.paymentModeService.getAllPaymentModes(req);
    } catch (error) {
      // return errorHandler(AllPaymentResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllPaymentResponseModel, error);
    }
  }
  @Post('/getAllActivePaymentModes')
  async getAllActivePaymentModes(): Promise<AllPaymentResponseModel> {
    try {
      return await this.paymentModeService.getAllActivePaymentModes();
    } catch (error) {
      // return errorHandler(AllPaymentResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllPaymentResponseModel, error);
    }
  }
}
